export default __webpack_public_path__ + "static/media/m_cycles3_eng.193420c0.png";